export interface DbGoal {
  id: string;
  user_id: string;
  title: string;
  description?: string | null;
  category?: string | null;
  progress: number;
  due_date?: string | null;
  status?: string | null;
  is_completed: boolean;
  goal_order?: number | null;
  created_at?: string;
  updated_at?: string;
  openai_thread_id?: string | null;  // ADDED
}

export interface Goal {
  id: string;
  title: string;
  description?: string | null;
  category?: string | null;
  progress: number;
  dueDate?: string | null;
  status?: string | null;
  isCompleted: boolean;
  goalOrder?: number | null;
  createdAt?: string;
  updatedAt?: string;
  openaiThreadId?: string | null;  // ADDED
  agentThreadId?: string;          // NEW: Agent thread ID for project chat
  projectTitle?: string;  // ADDED: Associated project title
  projectId?: string;     // ADDED: Associated project ID
  projectCoverImage?: string; // ADDED: Associated project cover image
}

// NEW: Interface for goal creation input from forms/modals
export interface GoalCreationInput {
  title: string;
  description?: string;
  category?: string;
  dueDate?: string;
}

// Add openai_thread_id to mapping
export function mapDbGoalToUiGoal(dbGoal: DbGoal): Goal {
  return {
    id: dbGoal.id,
    title: dbGoal.title,
    description: dbGoal.description ?? undefined,
    category: dbGoal.category ?? undefined,
    progress: dbGoal.progress,
    dueDate: dbGoal.due_date ?? undefined,
    status: dbGoal.status ?? undefined,
    isCompleted: dbGoal.is_completed,
    goalOrder: dbGoal.goal_order ?? undefined,
    createdAt: dbGoal.created_at,
    updatedAt: dbGoal.updated_at,
    openaiThreadId: dbGoal.openai_thread_id ?? undefined,
    agentThreadId: undefined, // Will be set by createGoal function
    projectTitle: undefined,
    projectId: undefined,
    projectCoverImage: undefined,
  };
}

export function mapUiGoalToDbGoal(uiGoal: Goal, userId: string): Omit<DbGoal, "created_at" | "updated_at"> {
  return {
    id: uiGoal.id,
    user_id: userId,
    title: uiGoal.title,
    description: uiGoal.description ?? null,
    category: uiGoal.category ?? null,
    progress: uiGoal.progress,
    due_date: uiGoal.dueDate ?? null,
    status: uiGoal.status ?? null,
    is_completed: uiGoal.isCompleted,
    goal_order: uiGoal.goalOrder ?? 0,
    openai_thread_id: uiGoal.openaiThreadId ?? null,
  };
}

// NEW: Mapping function for goal creation with proper defaults and field name handling
export function mapGoalCreationInputToGoal(input: GoalCreationInput): Omit<Goal, "id" | "createdAt" | "updatedAt" | "projectTitle" | "projectId" | "projectCoverImage" | "agentThreadId"> {
  return {
    title: input.title,
    description: input.description,
    category: input.category,
    progress: 0,
    dueDate: input.dueDate,
    status: null,
    isCompleted: false,
    goalOrder: 0,
    openaiThreadId: undefined,
  };
}
